import React from "react";

import mock06 from '../assets/images/redbus.png';
import mock07 from '../assets/images/Hr.png';
import mock08 from '../assets/images/todo.png';
import euroswift from '../assets/images/EuroSWift.png';
import chatApp from '../assets/images/Chat-App-.png';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://email-chatapp.netlify.app" target="_blank" rel="noreferrer"><img src={chatApp} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://email-chatapp.netlify.app" target="_blank" rel="noreferrer"><h2>Chat App</h2></a>
                <p>Developed A responsive and real-time chat application built using React, Redux, and Firebase, with support for email-based messaging, authentication, and dark/light mode.

</p>
            </div>
            <div className="project">
                <a href="https://euroswiftlanding.netlify.app/" target="_blank" rel="noreferrer"><img src={euroswift} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://euroswiftlanding.netlify.app/" target="_blank" rel="noreferrer"><h2>Euro swift</h2></a>
                <p>Euro Swift is a professional nurse recruitment website built using Next.js and Tailwind CSS. It serves as a platform to connect qualified nurses with healthcare institutions across Europe, showcasing available opportunities, benefits, and streamlined application processes.</p>
            </div>
            <div className="project">
                <a href="https://8byte-todoapp.netlify.app/" target="_blank" rel="noreferrer"><img src={mock08} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://8byte-todoapp.netlify.app/" target="_blank" rel="noreferrer"><h2>ToDo App </h2></a>
                <p>Developed This project is a complete Todo List Application built with React. It features two types of task management: manual entry and API-based todos fetched from JSONPlaceholder. It's fully responsive and uses pure CSS for styling and Features Traging move Undo and Redo.</p>
            </div>
            <div className="project">
                <a href="https://677b69f6951855d7f019e4b1--bleap.netlify.app/" target="_blank" rel="noreferrer"><img src={mock07} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://677b69f6951855d7f019e4b1--bleap.netlify.app/" target="_blank" rel="noreferrer"><h2>HR Organow</h2></a>
                <p>
  Master HR Analytics and AI with Orgaknow Academy!  
  Upskill, get certified, and lead with data-driven HR strategies.  
  This project was developed as a freelance assignment using React and Tailwind CSS.
</p>

            </div>
            <div className="project">
                <a href="https://github.com/baranidharan11/redBus-web.git" target="_blank" rel="noreferrer"><img src={mock06} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/baranidharan11/redBus-web.git" target="_blank" rel="noreferrer"><h2>Red Bus</h2></a>
                <p>This is the backend of a RedBus-like online bus booking system developed using Node.js and Express.js. It provides RESTful APIs to handle core functionalities such as bus listings, bookings, user authentication, schedules, and ticket management.</p>
            </div>
            
        </div>
    </div>
    );
}

export default Project;